import React from 'react';
import {
    StyledContainer,
    StyledContent,
    StyledContentContainer,
    StyledContentText,
    StyledDeleteImage,
    StyledEditImage,
    StyledLabelText,
    StyledNameContainer,
    AbsoluteContainer,
    MarginContainer,
    StyledAlignContainer
} from '../MemberCard/styles';
import { NameIcon } from '../../atoms';
import { EditIcon, DeleteIcon } from '../../../assets/img';
import { INomineeCard } from './types';


const NomineeMemberCard: React.FunctionComponent<INomineeCard> = ({
    firstName,
    lastName,
    relationship,
    doB,
    gender,
    percentage,
    onMemberDelete,
    onMemberEdit,
    color
}) => {
    return (
        <StyledContainer>
            <AbsoluteContainer>
                <StyledEditImage onClick={onMemberEdit} src={EditIcon}/>
                {relationship?.toLowerCase() !== 'self' && (
                    <StyledDeleteImage onClick={onMemberDelete} src={DeleteIcon}/>
                )}
            </AbsoluteContainer>
            <StyledNameContainer>
                <MarginContainer>
                    <NameIcon firstName={firstName} lastName={lastName || ''} color={color}/>
                </MarginContainer>
                <StyledContent>
                    <StyledLabelText>Name</StyledLabelText>
                    <StyledContentText>
                        <b>{firstName + ' ' + (lastName || '')}</b>
                    </StyledContentText>
                </StyledContent>
            </StyledNameContainer>
            <StyledContentContainer>
                <StyledAlignContainer>
                    <StyledContent>
                        <StyledLabelText>Relationship</StyledLabelText>
                        <StyledContentText>{relationship}</StyledContentText>
                    </StyledContent>
                    <StyledContent>
                        <StyledLabelText>DOB</StyledLabelText>
                        <StyledContentText>{doB}</StyledContentText>
                    </StyledContent>
                </StyledAlignContainer>
                <StyledAlignContainer>
                    <StyledContent>
                        <StyledLabelText>Gender</StyledLabelText>
                        <StyledContentText>{gender}</StyledContentText>
                    </StyledContent>
                    <StyledContent>
                        <StyledLabelText>Percentage SI</StyledLabelText>
                        <StyledContentText>{percentage}</StyledContentText>
                    </StyledContent>
                </StyledAlignContainer>
            </StyledContentContainer>
        </StyledContainer>
    );
};

export default NomineeMemberCard;
